import React, { useState } from 'react';
import {
    Box,
    Typography,
    Grid,
    Paper,
    Divider,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    Chip,
    Card,
    CardContent,
    Link,
    Button,
    Avatar
} from '@mui/material';

import AccessTimeIcon from '@mui/icons-material/AccessTime';
import PeopleOutlineIcon from '@mui/icons-material/PeopleOutline';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import SelfImprovementIcon from '@mui/icons-material/SelfImprovement';
import TipsAndUpdatesIcon from '@mui/icons-material/TipsAndUpdates';
import BookmarkIcon from '@mui/icons-material/Bookmark';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import FormatQuoteIcon from '@mui/icons-material/FormatQuote';

// スクロール用の関数
const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
        const offset = 80; // ヘッダーの高さ分のオフセット
        const elementPosition = element.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - offset;

        window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
        });
    }
};

const PostContent = () => {
    const [showToc, setShowToc] = useState(true);
    return (
        <Box sx={{ maxWidth: 800, mx: 'auto', px: { xs: 1, sm: 3 } }}>
            {/* 目次 */}
            {showToc ? (
                <Card sx={{ mb: 4, boxShadow: 2, bgcolor: '#e3f2fd', border: '1px solid #ddd', borderRadius: 2 }}>
                    <CardContent sx={{ p: 2 }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                            <Typography variant="h6" sx={{ flexGrow: 1 }}>目次</Typography>
                            <Button variant="outlined" size="small" onClick={() => setShowToc(false)}>閉じる</Button>
                        </Box>
                        <List sx={{ p: 0 }}>
                            <ListItem sx={{ p: 0.5, display: 'flex', alignItems: 'center' }}>
                                <Box sx={{ minWidth: 32, minHeight: 32, bgcolor: '#f5f5f5', color: '#888', fontWeight: 'bold', fontSize: '1.2rem', borderRadius: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', mr: 1 }}>
                                    1.
                                </Box>
                                <Link component="button" onClick={() => scrollToSection('introduction')} color="inherit" underline="hover" sx={{ cursor: 'pointer', fontSize: '0.95rem' }}>
                                    ルームシェアで「自分の時間」はなぜ大切？
                                </Link>
                            </ListItem>
                            <ListItem sx={{ p: 0.5, display: 'flex', alignItems: 'center' }}>
                                <Box sx={{ minWidth: 32, minHeight: 32, bgcolor: '#f5f5f5', color: '#888', fontWeight: 'bold', fontSize: '1.2rem', borderRadius: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', mr: 1 }}>
                                    2.
                                </Box>
                                <Link component="button" onClick={() => scrollToSection('how-to-get-alone-time')} color="inherit" underline="hover" sx={{ cursor: 'pointer', fontSize: '0.95rem' }}>
                                    一人時間の作り方とコツ
                                </Link>
                            </ListItem>
                            <ListItem sx={{ p: 0.5, display: 'flex', alignItems: 'center' }}>
                                <Box sx={{ minWidth: 32, minHeight: 32, bgcolor: '#f5f5f5', color: '#888', fontWeight: 'bold', fontSize: '1.2rem', borderRadius: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', mr: 1 }}>
                                    3.
                                </Box>
                                <Link component="button" onClick={() => scrollToSection('distance-balance')} color="inherit" underline="hover" sx={{ cursor: 'pointer', fontSize: '0.95rem' }}>
                                    距離感の保ち方・人間関係のコツ
                                </Link>
                            </ListItem>
                            <ListItem sx={{ p: 0.5, display: 'flex', alignItems: 'center' }}>
                                <Box sx={{ minWidth: 32, minHeight: 32, bgcolor: '#f5f5f5', color: '#888', fontWeight: 'bold', fontSize: '1.2rem', borderRadius: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', mr: 1 }}>
                                    4.
                                </Box>
                                <Link component="button" onClick={() => scrollToSection('hobby-usage')} color="inherit" underline="hover" sx={{ cursor: 'pointer', fontSize: '0.95rem' }}>
                                    趣味を活用した自分時間の充実法
                                </Link>
                            </ListItem>
                            <ListItem sx={{ p: 0.5, display: 'flex', alignItems: 'center' }}>
                                <Box sx={{ minWidth: 32, minHeight: 32, bgcolor: '#f5f5f5', color: '#888', fontWeight: 'bold', fontSize: '1.2rem', borderRadius: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', mr: 1 }}>
                                    5.
                                </Box>
                                <Link component="button" onClick={() => scrollToSection('real-experience')} color="inherit" underline="hover" sx={{ cursor: 'pointer', fontSize: '0.95rem' }}>
                                    体験談：私が見つけたベストな「自分時間」
                                </Link>
                            </ListItem>
                            <ListItem sx={{ p: 0.5, display: 'flex', alignItems: 'center' }}>
                                <Box sx={{ minWidth: 32, minHeight: 32, bgcolor: '#f5f5f5', color: '#888', fontWeight: 'bold', fontSize: '1.2rem', borderRadius: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', mr: 1 }}>
                                    6.
                                </Box>
                                <Link component="button" onClick={() => scrollToSection('summary-tips')} color="inherit" underline="hover" sx={{ cursor: 'pointer', fontSize: '0.95rem' }}>
                                    まとめと実践のヒント
                                </Link>
                            </ListItem>
                        </List>
                    </CardContent>
                </Card>
            ) : (
                <Button
                    variant="outlined"
                    size="small"
                    onClick={() => setShowToc(true)}
                    sx={{ mb: 2 }}
                >
                    目次を表示
                </Button>
            )}
            {/* 導入・イントロダクション */}
            <Box id="introduction" sx={{ mb: 4 }}>
                <Typography variant="h4" component="h2" gutterBottom>
                    ルームシェアで「自分の時間」はなぜ大切？
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                    ルームシェア生活は、住居コストの節約だけでなく、多様な人との出会いや刺激を得られる魅力的な暮らし方です。しかし、共同生活ならではの悩みもつきもの。その代表格が、「自分の時間をどう確保するか」ではないでしょうか。
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                    他人と一緒に暮らすことで、生活リズムやプライバシー、趣味の時間が制限されることも。そんな中でも「自分らしさ」を失わずに、自分だけのリラックスタイムを持てる方法を知ることで、ルームシェアの楽しさも倍増します。
                </Typography>
                <Typography variant="body2" sx={{ mb: 2, color: 'text.secondary' }}>
                    本記事では、実際の経験や専門的な視点から、ルームシェアで「自分の時間」を上手に作るためのコツやアイデアを詳しくご紹介します。
                </Typography>
                <Grid container spacing={2} sx={{ mt: 2 }}>
                    <Grid item xs={12} sm={6}>
                        <Box
                            component="img"
                            src="/images/blog/modern-roommate-dining_roomshare-alone-time-tips.jpg"
                            alt="明るい共有リビングでルームメイトたちがランチを楽しむ様子。ナチュラルな木目調のインテリアと開放感ある窓から光が差し込む、調和のとれた雰囲気"
                            sx={{
                                width: '100%',
                                borderRadius: 2,
                                boxShadow: 1,
                                mb: { xs: 2, sm: 0 }
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', height: '100%' }}>
                            <Chip icon={<AccessTimeIcon />} label="自分時間の確保" color="primary" variant="outlined" sx={{ mb: 1, fontWeight: 'bold' }} />
                            <Chip icon={<PeopleOutlineIcon />} label="ルームシェアのコツ" color="primary" variant="outlined" sx={{ mb: 1, fontWeight: 'bold' }} />
                            <Chip icon={<SelfImprovementIcon />} label="ストレスフリー生活" color="primary" variant="outlined" sx={{ mb: 1, fontWeight: 'bold' }} />
                        </Box>
                    </Grid>
                </Grid>
            </Box>

            {/* 一人時間の作り方 */}
            <Box id="how-to-get-alone-time" sx={{ mb: 4 }}>
                <Typography variant="h4" component="h2" gutterBottom>
                    一人時間の作り方とコツ
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                    ルームシェアでも「一人になれる時間」は、心のリセットや集中、趣味の充実に不可欠です。まずは、実践しやすい「自分時間」の作り方をチェックしましょう。
                </Typography>
                <Divider sx={{ my: 2 }} />
                <List>
                    <ListItem sx={{ alignItems: 'flex-start' }}>
                        <ListItemIcon>
                            <BookmarkIcon color="primary" />
                        </ListItemIcon>
                        <ListItemText
                            primary={
                                <Typography variant="h6" sx={{ fontWeight: 'bold' }}>1. 明確な「自分時間」を決めて伝える</Typography>
                            }
                            secondary={
                                <Typography variant="body2">
                                    例えば「週に2回は夜22時以降は自室で過ごす」など、具体的な時間をルームメイトと共有すると、お互いに気兼ねなく過ごせます。
                                </Typography>
                            }
                        />
                    </ListItem>
                    <ListItem sx={{ alignItems: 'flex-start' }}>
                        <ListItemIcon>
                            <BookmarkIcon color="primary" />
                        </ListItemIcon>
                        <ListItemText
                            primary={
                                <Typography variant="h6" sx={{ fontWeight: 'bold' }}>2. イヤホンや音楽で「マイ空間」を演出</Typography>
                            }
                            secondary={
                                <Typography variant="body2">
                                    リビングで過ごすときも、イヤホンやヘッドホンを活用して自分の世界に没頭することで、周囲と適度な距離を保てます。
                                </Typography>
                            }
                        />
                    </ListItem>
                    <ListItem sx={{ alignItems: 'flex-start' }}>
                        <ListItemIcon>
                            <BookmarkIcon color="primary" />
                        </ListItemIcon>
                        <ListItemText
                            primary={
                                <Typography variant="h6" sx={{ fontWeight: 'bold' }}>3. 共有スペースと自室を上手に使い分け</Typography>
                            }
                            secondary={
                                <Typography variant="body2">
                                    共有リビングで人が多いときは自室へ、逆に誰もいない時間帯を見計らってリビングを独占するなど、生活リズムを観察して使い分けましょう。
                                </Typography>
                            }
                        />
                    </ListItem>
                    <ListItem sx={{ alignItems: 'flex-start' }}>
                        <ListItemIcon>
                            <BookmarkIcon color="primary" />
                        </ListItemIcon>
                        <ListItemText
                            primary={
                                <Typography variant="h6" sx={{ fontWeight: 'bold' }}>4. 外で自分時間を楽しむ</Typography>
                            }
                            secondary={
                                <Typography variant="body2">
                                    カフェや公園、図書館など、家の外にも「一人になれる場所」を持つことで、気分転換にもなります。
                                </Typography>
                            }
                        />
                    </ListItem>
                </List>
                <Divider sx={{ my: 2 }} />
                <Box
                    component="img"
                    src="/images/blog/alone-time-cafe_roomshare-alone-time-tips.jpg"
                    alt="落ち着いた雰囲気のカフェで一人静かに本を読む女性。木製テーブルと観葉植物が温かみを演出し、外での自分時間の大切さを感じさせる"
                    sx={{
                        width: '100%',
                        borderRadius: 2,
                        boxShadow: 1,
                        mt: 2
                    }}
                />
            </Box>

            {/* 距離感の保ち方 */}
            <Box id="distance-balance" sx={{ mb: 4 }}>
                <Typography variant="h4" component="h2" gutterBottom>
                    距離感の保ち方・人間関係のコツ
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                    ルームシェア生活を快適に保つには、「近すぎず、遠すぎず」の関係性がカギ。良好な人間関係を築きつつ、自分のペースも守るためのポイントをまとめました。
                </Typography>
                <Paper elevation={2} sx={{ p: 2, borderRadius: 2, mb: 2, bgcolor: '#fafafa' }}>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={6}>
                            <Typography variant="h6" sx={{ mb: 1, display: 'flex', alignItems: 'center' }}>
                                <TipsAndUpdatesIcon sx={{ mr: 1, color: 'primary.main' }} />
                                距離感バランスのコツ
                            </Typography>
                            <List dense>
                                <ListItem>
                                    <ListItemIcon>
                                        <CheckCircleOutlineIcon color="success" />
                                    </ListItemIcon>
                                    <ListItemText
                                        primary="あいさつと感謝はしっかり伝える"
                                        secondary="最低限の礼儀を守ることで信頼関係が生まれ、余計なトラブルも防げます。"
                                    />
                                </ListItem>
                                <ListItem>
                                    <ListItemIcon>
                                        <CheckCircleOutlineIcon color="success" />
                                    </ListItemIcon>
                                    <ListItemText
                                        primary="「今日は静かに過ごしたい」と素直に伝える"
                                        secondary="無理に付き合わず、気持ちを言葉にする勇気も大切。"
                                    />
                                </ListItem>
                                <ListItem>
                                    <ListItemIcon>
                                        <CheckCircleOutlineIcon color="success" />
                                    </ListItemIcon>
                                    <ListItemText
                                        primary="共有ルールや掃除担当を明確に"
                                        secondary="曖昧にせず、事前に話し合うことで摩擦が減ります。"
                                    />
                                </ListItem>
                                <ListItem>
                                    <ListItemIcon>
                                        <CheckCircleOutlineIcon color="success" />
                                    </ListItemIcon>
                                    <ListItemText
                                        primary="適度に誘いを断る勇気も持つ"
                                        secondary="みんなと過ごす時間だけでなく、自分のリズムも意識しましょう。"
                                    />
                                </ListItem>
                            </List>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            
                        </Grid>
                    </Grid>
                </Paper>
                <Typography variant="body2" sx={{ color: 'text.secondary', mt: 1 }}>
                    距離感やルールを上手にコントロールできると、共同生活はもっと快適に。トラブルを未然に防ぐためにも、日頃のコミュニケーションを大切にしましょう。
                </Typography>
            </Box>

            {/* 趣味の活用 */}
            <Box id="hobby-usage" sx={{ mb: 4 }}>
                <Typography variant="h4" component="h2" gutterBottom>
                    趣味を活用した自分時間の充実法
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                    趣味は「自分らしさ」を保つ最高のツール。ルームシェアでも趣味を活かして、自分の時間をより有意義に過ごす工夫をしてみましょう。
                </Typography>
                <Paper elevation={1} sx={{ p: 2, borderRadius: 2, bgcolor: '#f3e5f5', mb: 2 }}>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={7}>
                            <Typography variant="h6" sx={{ mb: 1 }}>
                                <FavoriteBorderIcon sx={{ mr: 1, color: 'secondary.main' }} />
                                ルームシェア×趣味の楽しみ方
                            </Typography>
                            <List dense>
                                <ListItem>
                                    <ListItemIcon>
                                        <FavoriteBorderIcon color="secondary" />
                                    </ListItemIcon>
                                    <ListItemText
                                        primary="ひとり趣味を大切に"
                                        secondary="読書・映画・手芸・楽器など、自室や静かなスペースで好きな時間を満喫。"
                                    />
                                </ListItem>
                                <ListItem>
                                    <ListItemIcon>
                                        <PeopleOutlineIcon color="primary" />
                                    </ListItemIcon>
                                    <ListItemText
                                        primary="趣味をシェアして交流も"
                                        secondary="料理やボードゲーム、映画鑑賞会など、時にはルームメイトと共通の趣味を楽しんでみても◎"
                                    />
                                </ListItem>
                                <ListItem>
                                    <ListItemIcon>
                                        <SelfImprovementIcon color="success" />
                                    </ListItemIcon>
                                    <ListItemText
                                        primary="集中タイムの確保"
                                        secondary="「この時間は集中したい」と伝えておくことで、趣味に没頭できる環境を作れます。"
                                    />
                                </ListItem>
                            </List>
                        </Grid>
                        <Grid item xs={12} sm={5}>
                            <Box
                                component="img"
                                src="/images/blog/private-hobby-space_roomshare-alone-time-tips.jpg"
                                alt="シンプルな個室で静かにギターを弾く男性。ナチュラルカラーのインテリアと柔らかな照明が、趣味に没頭する穏やかな一人時間を演出"
                                sx={{
                                    width: '100%',
                                    borderRadius: 2,
                                    boxShadow: 1
                                }}
                            />
                        </Grid>
                    </Grid>
                </Paper>
                <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                    趣味を通じて「自分の世界」を持つことは、ストレス発散にもつながります。時にはルームメイトとの新しい交流のきっかけにもなるでしょう。
                </Typography>
            </Box>

            {/* 体験談 */}
            <Box id="real-experience" sx={{ mb: 4 }}>
                <Typography variant="h4" component="h2" gutterBottom>
                    体験談：私が見つけたベストな「自分時間」
                </Typography>
                <Box sx={{ display: 'flex', alignItems: 'flex-start', mb: 2 }}>
                    <FormatQuoteIcon sx={{ fontSize: 40, color: 'primary.main', mr: 1, mt: 0.5 }} />
                    <Typography variant="body1" sx={{ fontStyle: 'italic' }}>
                        「最初は共同生活に不安もありましたが、思い切って『毎週日曜はカフェで一人読書』と決めてから、気持ちに余裕ができました。ルームメイトにもその時間は干渉しないよう伝えたことで、気まずさもなくなり、お互いが自分時間を尊重する雰囲気になりました。今では、家の中でもイヤホンを活用するなど、自分なりのリラックス法が見つかっています。」
                    </Typography>
                </Box>
                <Typography variant="body2" sx={{ mb: 2, color: 'text.secondary' }}>
                    ルームシェア経験者からは「自分時間を明確にすることで、逆に人間関係も良好になった」という声が多く聞かれます。周囲を気にしすぎず、自分のスタイルを持つことが大切です。
                </Typography>
            </Box>

            {/* まとめと実践のヒント */}
            <Box id="summary-tips" sx={{ mb: 4 }}>
                <Typography variant="h4" component="h2" gutterBottom>
                    まとめと実践のヒント
                </Typography>
                <Paper elevation={1} sx={{ p: 2, borderRadius: 2, bgcolor: '#e8f5e9', mb: 2 }}>
                    <Typography variant="body1" sx={{ mb: 1, fontWeight: 'bold' }}>
                        ルームシェアで「自分の時間」を確保するためのポイント
                    </Typography>
                    <List dense>
                        <ListItem>
                            <ListItemIcon>
                                <CheckCircleOutlineIcon color="success" />
                            </ListItemIcon>
                            <ListItemText
                                primary="自分の時間帯・方法を明確にして伝える"
                            />
                        </ListItem>
                        <ListItem>
                            <ListItemIcon>
                                <CheckCircleOutlineIcon color="success" />
                            </ListItemIcon>
                            <ListItemText
                                primary="距離感は「近すぎず遠すぎず」を意識"
                            />
                        </ListItem>
                        <ListItem>
                            <ListItemIcon>
                                <CheckCircleOutlineIcon color="success" />
                            </ListItemIcon>
                            <ListItemText
                                primary="趣味や外出を活用してマイペースを保つ"
                            />
                        </ListItem>
                        <ListItem>
                            <ListItemIcon>
                                <CheckCircleOutlineIcon color="success" />
                            </ListItemIcon>
                            <ListItemText
                                primary="小さな違和感もきちんと伝える勇気を持つ"
                            />
                        </ListItem>
                    </List>
                </Paper>
                <Typography variant="body2" sx={{ mb: 2 }}>
                    ルームシェアは「自分の時間」と「みんなの時間」のバランスが大切。少しの工夫と勇気で、心地よい共同生活を手に入れてください。
                </Typography>
                <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
                    <Chip label="ルームシェア生活をもっと快適に！" color="primary" variant="filled" sx={{ fontWeight: 'bold', px: 2, py: 1, fontSize: '1.1rem' }} />
                </Box>
            </Box>
        </Box>
    );
};

const post = {
    id: 'roomshare-alone-time-tips',
    slug: 'roomshare-alone-time-tips',
    title: 'ルームシェアで「自分の時間」を確保するコツ',
    excerpt: '一人時間の作り方、距離感の保ち方、趣味の活用、体験談などを踏まえて快適なルームシェア生活のヒントを紹介します。',
    coverImage: '/images/blog/cover-modern-sharehouse_roomshare-alone-time-tips.jpg',
    coverImageAlt: '明るい自然光が差し込むモダンなルームシェアの共有リビングで、多様な背景を持つルームメイトたちが楽しく会話をしている様子。インテリアはナチュラルカラー基調で、開放感と温かみのある雰囲気が伝わる',
    publishedAt: '2024-06-11T09:00:00+09:00',
    isPublished: true,
    categories: ['ルームシェア', '暮らしのコツ', '人間関係'],
    tags: ['一人時間', 'シェアハウス', 'プライバシー', '趣味', 'コミュニケーション'],
    author: {
        name: '矢野 みさき',
        avatar: '/images/avatars/misaki-yano.jpg',
        bio: 'シェアハウス歴8年。複数の物件でルームメイトとの快適な暮らし方を研究。多様な視点から共同生活のヒントを発信中。',
        profilePicture: '/images/avatars/misaki-yano.jpg'
    },
    viewCount: 1042,
    contentComponent: PostContent
};

export default post;